import { makeStyles } from '@mui/styles';
import FileUpload from 'apollo-react/components/FileUpload';
import Loader from 'apollo-react/components/Loader';
import Modal from 'apollo-react/components/Modal';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { handleErrors } from '../../actions/ErrorActions';
import { useTranslation } from '../../custom-hooks/useTranslation';

const useStyles = makeStyles({
  modal: {
    width: 500,
  },
});

const ImportConfigDatasourceModal = ({
  open,
  onClose,
  importConfigDatasourceFile,
  validateXml,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const translateString = useTranslation();
  const [isImporting, setIsImporting] = useState(false);
  const [file, setFile] = useState(null);
  const [xml, setXml] = useState(null);
  const [value, setValue] = useState([]);

  useEffect(() => {
    if (!open) {
      resetState();
    }
  }, [open]);

  const resetState = () => {
    setFile(null);
    setXml(null);
    setIsImporting(false);
  };

  const handleFileChange = (selectedFile) => {
    if (!selectedFile) {
      return;
    }

    setValue((prevValue) => [...prevValue, ...selectedFile]);

    const reader = new FileReader();
    reader.onload = (e) => {
      setXml(e.target.result);
      setFile(selectedFile[0].name);
    };

    reader.readAsText(selectedFile[0]);
  };

  const convertKeysToLowerCase = (obj) => {
    if (Array.isArray(obj)) {
      return obj.map(convertKeysToLowerCase);
    } else if (obj && typeof obj === 'object') {
      return Object.keys(obj).reduce((acc, key) => {
        const newKey = key === 'SelectValueColumns' ? 'selectValueColumns' : key.toLowerCase();
        acc[newKey] = convertKeysToLowerCase(obj[key]);
        return acc;
      }, {});
    }
    return obj;
  };

  const handleSave = async () => {
    try {
      setIsImporting(true);
      const xmlToJsonData = validateXml({ xml });
      await importConfigDatasourceFile(convertKeysToLowerCase(xmlToJsonData));
    } catch (error) {
      dispatch(handleErrors(error));
    } finally {
      setIsImporting(false);
      onClose();
    }
  };

  const handleDelete = (fileToDelete) => {
    setValue((prevValue) => prevValue.filter((item) => item.name !== fileToDelete.name));
    setFile(null);
  };

  return (
    <Modal
      open={open}
      variant="default"
      onClose={onClose}
      title={translateString('Import File')}
      buttonProps={[
        {
          label: translateString('Cancel'),
          'ui-ta': 'ImportFileModal-CancelButton',
        },
        {
          label: translateString('Import'),
          onClick: handleSave,
          disabled: !file,
          'ui-ta': 'ImportFileModal-ImportButton',
        },
      ]}
      className={classes.modal}
      disableBackdropClick
      disableEscapeKeyDown
    >
      <FileUpload
        fullWidth
        value={value}
        label={`${translateString('Click Browse to select a file')}.`}
        accept="text/xml"
        onUpload={handleFileChange}
        onFileDelete={handleDelete}
        maxItems={1}
      />
      {isImporting && <Loader isInner />}
    </Modal>
  );
};

export default ImportConfigDatasourceModal;
